module.exports = __webpack_public_path__ + "static/media/slider2.2a4de0e8.png";